// @flow
import React from "react";
import { useSelector } from "react-redux";
import { isEmpty, range } from "ramda";

import { type ErrosSelecao } from "../../../../model";

import {
  type State,
  comGeradorDePeriodo,
  getCamposSelecionados,
  getCompradoresSelecionados,
  i18n,
  getAjusteDiasSelecionado,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../../state";

import {
  SelecaoAjusteDias,
  SelecaoCampos,
  SelecaoCompradores,
  SelecaoPeriodo,
  SelecaoCasasDecimais,
} from "../../configuracoes";

import { randomId } from "../../../../util";

export const criaFuncaoValidacaoPontualMensalComprador = (
  state: State
) => (): ?ErrosSelecao => {
  const erros: ErrosSelecao = {};
  const { translate } = i18n(state);

  if (isEmpty(getCamposSelecionados(state)))
    erros.campoNaoSelecionado = translate(
      "configuracaoRelatorio.erroMedidaSemCampoSelecionado"
    );

  return erros;
};

export const processarPontualMensalComprador = comGeradorDePeriodo(
  (state, medidas) => {
    const compradores = getCompradoresSelecionados(state);
    const campos = new Set(getCamposSelecionados(state));
    const ajusteDias = getAjusteDiasSelecionado(state);
    const modoSeries = isModoSeries(state);
    const idGrupoMedidasSelecionadas = randomId();

    return range(1, compradores + 1).flatMap(rankComprador =>
      medidas
        .filter(medidasSelecionada =>
          campos.has(medidasSelecionada.medida.codigoOriginal)
        )
        .map(medidasSelecionada => ({
          ...medidasSelecionada,
          idGrupoMedidasSelecionadas,
          rankComprador,
          ajusteDias: modoSeries ? null : ajusteDias,
          ...analiseValorDaMedida(medidasSelecionada, state),
        }))
    );
  }
);

const PontualMensalComprador = () => {
  const modoSeries = useSelector(isModoSeries);

  return (
    <>
      <div className="ConfiguracaoMedida--flex">
        <SelecaoPeriodo exibirPeriodicidade={false} />
      </div>

      <div className="ConfiguracaoMedida">
        <div className="ConfiguracaoMedida__box">
          <SelecaoAjusteDias />
        </div>

        <div className="ConfiguracaoMedida__box">
          <SelecaoCompradores />
        </div>
      </div>

      <div className="ConfiguracaoMedida__vertical-divider" />

      <div className="ConfiguracaoMedida">
        <SelecaoCampos />
      </div>

      {!modoSeries && (
        <>
          <div className="ConfiguracaoMedida__vertical-divider" />
          <SelecaoCasasDecimais />
        </>
      )}
    </>
  );
};

export default PontualMensalComprador;
